import {DG_axios} from "../../../../custom/axios";

const BASE_URL = `/dogoo/compensatory-config-rest/v2.0/compensatory-configurations/`;

export const loadCompensatoryConfigApi = async () => {
    const response = await DG_axios.get(BASE_URL)
    return response.data || [];
}

export const addCompensatoryConfigApi = async (compensatoryConfig) => {
    const response = await DG_axios.post(BASE_URL, compensatoryConfig);
    return response.data || [];
}